import api from ".";
import cookiesModifier from "../utils/cookies";

export const deleteOptionDetail = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`option-details/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}